import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Ursus Victor LLC - Professional Loan Application Support Services</title>
        <meta name="description" content="Expert loan application and documentation support services. We help you prepare complete, accurate loan applications. Not a lender - we support your application process." />
      </Helmet>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%)',
        color: 'white',
        padding: '6rem 2rem',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1920&h=1080&fit=crop&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.15
        }} />
        <div style={{maxWidth: '1100px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <div style={{maxWidth: '700px'}}>
            <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}>📋</div>
            <h1 style={{fontSize: '3.5rem', fontWeight: '900', marginBottom: '1.5rem', lineHeight: '1.1'}}>
              Your Loan Application Support Partner
            </h1>
            <p style={{fontSize: '1.4rem', marginBottom: '1rem', lineHeight: '1.6', opacity: 0.95}}>
              Professional assistance with loan applications and documentation preparation
            </p>
            <p style={{fontSize: '1.2rem', marginBottom: '2.5rem', opacity: 0.9, fontWeight: '600', background: 'rgba(255,255,255,0.2)', padding: '1rem', borderRadius: '8px', display: 'inline-block'}}>
              ⚠️ We provide support services — We are NOT a lender
            </p>
            <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
              <Link to="/contact" style={{
                background: 'white',
                color: '#1e40af',
                padding: '1.25rem 3rem',
                borderRadius: '12px',
                fontWeight: '800',
                fontSize: '1.2rem',
                boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
                transition: 'transform 0.3s'
              }}>
                Get Application Support
              </Link>
              <Link to="/services" style={{
                background: 'transparent',
                color: 'white',
                padding: '1.25rem 3rem',
                borderRadius: '12px',
                fontWeight: '800',
                fontSize: '1.2rem',
                border: '3px solid white'
              }}>
                View Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section style={{
        background: '#eff6ff',
        padding: '2rem',
        borderBottom: '2px solid #3b82f6'
      }}>
        <div style={{maxWidth: '1100px', margin: '0 auto', display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: '1.5rem', textAlign: 'center'}}>
          <div>
            <div style={{fontSize: '2rem', marginBottom: '0.5rem'}}>✓</div>
            <div style={{fontWeight: '700', color: '#1e40af'}}>Application Support</div>
          </div>
          <div>
            <div style={{fontSize: '2rem', marginBottom: '0.5rem'}}>✓</div>
            <div style={{fontWeight: '700', color: '#1e40af'}}>Not a Lender</div>
          </div>
          <div>
            <div style={{fontSize: '2rem', marginBottom: '0.5rem'}}>✓</div>
            <div style={{fontWeight: '700', color: '#1e40af'}}>Document Preparation</div>
          </div>
          <div>
            <div style={{fontSize: '2rem', marginBottom: '0.5rem'}}>✓</div>
            <div style={{fontWeight: '700', color: '#1e40af'}}>Professional Guidance</div>
          </div>
        </div>
      </section>

      {/* What We Do */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{fontSize: '3rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Professional Loan Application Support
            </h2>
            <p style={{fontSize: '1.3rem', color: '#64748b', maxWidth: '800px', margin: '0 auto 2rem'}}>
              We help you prepare complete, accurate loan applications with proper documentation
            </p>
            <div style={{
              background: '#fef3c7',
              padding: '1.5rem 2.5rem',
              borderRadius: '12px',
              display: 'inline-block',
              border: '3px solid #f59e0b',
              maxWidth: '700px'
            }}>
              <p style={{color: '#92400e', fontWeight: '800', margin: 0, fontSize: '1.1rem'}}>
                ⚠️ IMPORTANT: Ursus Victor LLC is a support services company. We do NOT lend money or make lending decisions.
              </p>
            </div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '2.5rem',
            marginTop: '4rem'
          }}>
            <div style={{
              background: '#f8fafc',
              padding: '2.5rem',
              borderRadius: '16px',
              border: '2px solid #e2e8f0',
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
            }}>
              <div style={{fontSize: '3.5rem', marginBottom: '1.5rem'}}>📝</div>
              <h3 style={{fontSize: '1.8rem', fontWeight: '800', color: '#1e40af', marginBottom: '1rem'}}>
                Application Assistance
              </h3>
              <p style={{color: '#475569', lineHeight: '1.8', fontSize: '1.05rem'}}>
                We guide you through the loan application process, helping you understand requirements and complete forms accurately.
              </p>
            </div>

            <div style={{
              background: '#f8fafc',
              padding: '2.5rem',
              borderRadius: '16px',
              border: '2px solid #e2e8f0',
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
            }}>
              <div style={{fontSize: '3.5rem', marginBottom: '1.5rem'}}>📄</div>
              <h3 style={{fontSize: '1.8rem', fontWeight: '800', color: '#1e40af', marginBottom: '1rem'}}>
                Document Preparation
              </h3>
              <p style={{color: '#475569', lineHeight: '1.8', fontSize: '1.05rem'}}>
                Professional support organizing financial documents, tax returns, business records, and supporting materials.
              </p>
            </div>

            <div style={{
              background: '#f8fafc',
              padding: '2.5rem',
              borderRadius: '16px',
              border: '2px solid #e2e8f0',
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
            }}>
              <div style={{fontSize: '3.5rem', marginBottom: '1.5rem'}}>✅</div>
              <h3 style={{fontSize: '1.8rem', fontWeight: '800', color: '#1e40af', marginBottom: '1rem'}}>
                Application Review
              </h3>
              <p style={{color: '#475569', lineHeight: '1.8', fontSize: '1.05rem'}}>
                Thorough review of your application package to ensure completeness and accuracy before submission.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section style={{padding: '5rem 2rem', background: '#f8fafc'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '3rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Complete Application Support Services
            </h2>
            <p style={{fontSize: '1.2rem', color: '#64748b'}}>
              Everything you need to prepare a professional loan application
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem'
          }}>
            {[
              { icon: '📋', title: 'Application Form Assistance', desc: 'Help completing loan application forms accurately' },
              { icon: '💼', title: 'Business Plan Support', desc: 'Guidance on preparing business plan documentation' },
              { icon: '📊', title: 'Financial Statement Prep', desc: 'Organizing financial statements and records' },
              { icon: '🏦', title: 'Bank Statement Organization', desc: 'Proper formatting and presentation of bank records' },
              { icon: '📑', title: 'Tax Return Compilation', desc: 'Gathering and organizing tax documentation' },
              { icon: '🔍', title: 'Document Verification', desc: 'Ensuring all required documents are complete' },
              { icon: '📧', title: 'Submission Guidance', desc: 'Instructions on proper application submission' },
              { icon: '💬', title: 'Follow-up Support', desc: 'Assistance with lender questions and requests' }
            ].map((service, index) => (
              <div key={index} style={{
                background: 'white',
                padding: '2rem',
                borderRadius: '12px',
                border: '2px solid #e2e8f0',
                transition: 'transform 0.3s, box-shadow 0.3s'
              }}>
                <div style={{fontSize: '3rem', marginBottom: '1rem'}}>{service.icon}</div>
                <h3 style={{fontSize: '1.3rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.75rem'}}>
                  {service.title}
                </h3>
                <p style={{color: '#64748b', lineHeight: '1.7'}}>
                  {service.desc}
                </p>
              </div>
            ))}
          </div>

          <div style={{textAlign: 'center', marginTop: '3rem'}}>
            <Link to="/services" style={{
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              color: 'white',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              fontWeight: '800',
              fontSize: '1.2rem',
              display: 'inline-block',
              boxShadow: '0 8px 24px rgba(30,64,175,0.3)'
            }}>
              Explore All Services
            </Link>
          </div>
        </div>
      </section>

      {/* Process */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1000px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Our Support Process
            </h2>
            <p style={{fontSize: '1.2rem', color: '#64748b'}}>
              Simple, straightforward application support from start to finish
            </p>
          </div>

          <div style={{display: 'grid', gap: '2rem'}}>
            {[
              { step: '1', title: 'Initial Consultation', desc: 'We discuss your loan needs and review application requirements', color: '#3b82f6' },
              { step: '2', title: 'Document Gathering', desc: 'We help you identify and collect all necessary documentation', color: '#2563eb' },
              { step: '3', title: 'Application Preparation', desc: 'We assist in completing application forms accurately and thoroughly', color: '#1d4ed8' },
              { step: '4', title: 'Review & Verification', desc: 'We review your complete application package for accuracy', color: '#1e40af' },
              { step: '5', title: 'Submission Guidance', desc: 'We provide instructions for submitting to your chosen lender', color: '#1e3a8a' }
            ].map((item, index) => (
              <div key={index} style={{
                display: 'flex',
                gap: '2rem',
                alignItems: 'center',
                padding: '2rem',
                background: '#f8fafc',
                borderRadius: '16px',
                border: '2px solid #e2e8f0'
              }}>
                <div style={{
                  background: item.color,
                  color: 'white',
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '2rem',
                  fontWeight: '900',
                  flexShrink: 0,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                  {item.step}
                </div>
                <div>
                  <h3 style={{fontSize: '1.6rem', fontWeight: '800', color: '#1e40af', marginBottom: '0.5rem'}}>
                    {item.title}
                  </h3>
                  <p style={{color: '#64748b', lineHeight: '1.7', fontSize: '1.05rem'}}>
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section style={{padding: '5rem 2rem', background: '#f8fafc'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '3rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Why Choose Ursus Victor LLC?
            </h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}>
            {[
              { icon: '🎯', title: 'Focused Expertise', desc: 'We specialize exclusively in loan application support services' },
              { icon: '⚡', title: 'Fast Turnaround', desc: 'Quick document review and application preparation assistance' },
              { icon: '🔒', title: 'Confidential Service', desc: 'Your financial information is handled with strict confidentiality' },
              { icon: '💯', title: 'Accuracy Focused', desc: 'Meticulous attention to detail in every application' },
              { icon: '🤝', title: 'Personal Support', desc: 'One-on-one guidance throughout the entire process' },
              { icon: '📚', title: 'Educational Approach', desc: 'We help you understand each step of the application' }
            ].map((item, index) => (
              <div key={index} style={{
                background: 'white',
                padding: '2.5rem',
                borderRadius: '16px',
                border: '2px solid #e2e8f0',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}>{item.icon}</div>
                <h3 style={{fontSize: '1.5rem', fontWeight: '800', color: '#1e40af', marginBottom: '1rem'}}>
                  {item.title}
                </h3>
                <p style={{color: '#64748b', lineHeight: '1.7'}}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #3b82f6 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h2 style={{fontSize: '3rem', fontWeight: '900', marginBottom: '1.5rem'}}>
            Ready to Get Started?
          </h2>
          <p style={{fontSize: '1.3rem', marginBottom: '2.5rem', opacity: 0.95, lineHeight: '1.6'}}>
            Let us help you prepare a complete, professional loan application package
          </p>
          <Link to="/contact" style={{
            background: 'white',
            color: '#1e40af',
            padding: '1.5rem 3.5rem',
            borderRadius: '12px',
            fontWeight: '900',
            fontSize: '1.3rem',
            display: 'inline-block',
            boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
          }}>
            Request Application Support
          </Link>
          <p style={{marginTop: '2rem', fontSize: '1rem', opacity: 0.9}}>
            ✓ Professional assistance • ✓ Confidential service • ✓ Fast turnaround
          </p>
        </div>
      </section>

      {/* Disclaimer */}
      <section style={{
        background: '#fef3c7',
        padding: '2.5rem 2rem',
        borderTop: '3px solid #f59e0b'
      }}>
        <div style={{maxWidth: '1000px', margin: '0 auto', textAlign: 'center'}}>
          <p style={{fontSize: '1rem', color: '#92400e', lineHeight: '1.8', fontWeight: '600'}}>
            <strong>IMPORTANT DISCLOSURE:</strong> Ursus Victor LLC provides loan application support and documentation services only. 
            We are NOT a lender, do NOT make loans, and do NOT make lending decisions. We do NOT guarantee loan approval. 
            All lending decisions are made solely by financial institutions. We assist with application preparation only.
          </p>
        </div>
      </section>
    </>
  );
};

export default Home;
